const information_card_store = {
    subscribers:{},
    station_id:undefined,
    obj_type: undefined,
    title: undefined,
    data_type: undefined,
    block: false,
    dam_id:undefined,
    getStationId(){
        return this.station_id
    },
    setStationId(id){
        this.station_id = id
        this.publish('SET_STATION_ID', {obj_id:id})
    },
    setObjType(type){
        this.obj_type = type
    },
    setBlockStatus(boolean){
        this.block = boolean
    },
    setDamId(id){
        this.dam_id = id
    },
    setDataType(data_type){
        this.data_type = data_type
    },
    getDamId(){
        return this.dam_id
    },
    getBlockStatus(){
        return this.block
    },
    getObjType(){
        return this.obj_type
    },
    getTitle(){
        return this.title
    },
    getDataType(){
        return this.data_type
    },
    setTitle(title){
        this.title = title
    },
    updateCardPosition(el){
        this.publish('UPDATE_CARD_POSITION', {el:el})
    },
    subscribe(topic, callback){
        if(!this.subscribers[topic]){
            this.subscribers[topic] = []
        }
        this.subscribers[topic].push(callback)
    },
    publish(topic, data){
        if(this.subscribers[topic]){
            this.subscribers[topic].forEach(callback => {
                callback(data);
            });
        }
    }
}

export default information_card_store